import React, { useEffect, useState } from "react";
import { FiCpu } from "react-icons/fi";
import { skillsService } from "../../services/skillsService";
import DocumentTitle from "../../components/ui/DocumentTitle";
import "./Skills.css";

const STATIC_FALLBACK = [
  { name: "Développement logiciel", items: [{ name: "React.js", level: "beginner" }] }
];

const getLevelPercent = (level) => {
  const map = { expert: "95%", advanced: "75%", intermediate: "55%", beginner: "35%" };
  return map[level] || "45%";
};

const getLevelLabel = (level) => {
  const map = { expert: "Niv. Expert", advanced: "Niv. Avancé", intermediate: "Niv. Intermédiaire", beginner: "Niv. Débutant" };
  return map[level] || "Niv. Débutant";
};

function Skills() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await skillsService.getAll();
        const cats = data?.categories || (Array.isArray(data) ? data : []);
        if (mounted) setCategories(cats);
      } catch (e) {
        if (mounted) setError("Service de compétences indisponible");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const toRender = categories.length > 0 ? categories : STATIC_FALLBACK;

  return (
    <div className="skills-page-tech">
      <DocumentTitle title="Compétences" />

      <header className="tech-header">
        <div className="container">
          <h1 className="page-title"><FiCpu /> Compétences Techniques</h1>
        </div>
      </header>

      <main className="container">
        {error && <div className="error-state">{error}</div>}
        {loading && <div className="loading-state">Analyse en cours...</div>}

        {!loading && toRender.map((cat, idx) => (
          <section key={cat.name} className="tech-section">
            <div className="section-meta">
              <span className="section-index">0{idx + 1}</span>
              <h2 className="section-label">{cat.name}</h2>
            </div>

            <div className="tech-grid">
              {(cat.skills || cat.items || []).map((skill) => {
                const name = typeof skill === 'string' ? skill : skill.name;
                const level = skill.level || "intermediate";
                return (
                  <div key={name} className="tech-card">
                    <div className="card-header">
                      <span className="skill-name">{name}</span>
                      <span className="skill-level-text">{getLevelLabel(level)}</span>
                    </div>
                    <div className="progress-track">
                      <div 
                        className={`progress-fill ${level}`} 
                        style={{ width: getLevelPercent(level) }}
                      ></div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}

export default Skills;